<i18n src="./langs.yaml"></i18n>
<template>
  <div class="delivery-guide-wrapper">
    <div
      v-for="item in pageCfg"
      :key="item.key"
      class="delivery-guide-content-item"
    >
      <div
        v-if="item.type === 'text'"
        class="text-wrapper"
        :style="$t('textWrapper.style')"
        v-html="$options.filters.content(area, item)"
      />
      <div v-if="item.type === 'hr'" class="hr" />
      <div
        v-if="item.type === 'textWithdoubleImg'"
        class="text-with-double-img-wrapper"
        :style="$t('textWrapper.style')"
      >
        <div
          :style="$t('textWrapper.style')"
          class="describe-content"
          v-html="item.content"
        />
        <div :style="$t('textWrapper.style')" class="figure-wrapper">
          {{ $t('figure') }}
        </div>
        <div
          v-for="(imgItem, index) in item.imgList"
          :key="index"
          class="img-list-wrapper"
        >
          <div class="img-item-top-wrapper">
            <div class="img-item-wrapper">
              <img
                v-lazy="
                  getImgSrcWithOSSResize(imgItem.leftImg, imgItem.leftNoResize)
                "
                class="img-item"
                alt=""
              />
            </div>
            <div class="img-item-wrapper">
              <img
                v-lazy="
                  getImgSrcWithOSSResize(
                    imgItem.rightImg,
                    imgItem.rightNoResize,
                  )
                "
                class="img-item"
                alt=""
              />
            </div>
          </div>
          <div class="mark-bottom-wrapper">
            <div class="img-mark-wrapper">
              <img
                :src="
                  require(imgItem.leftType === 'error'
                    ? './static/error-icon.png'
                    : './static/correct-icon.png')
                "
                alt=""
                class="img-mark-icon"
              />
              <div :style="$t('remark.style')" class="img-mark">
                {{ imgItem.leftMark }}
              </div>
            </div>
            <div class="img-mark-wrapper">
              <img
                :src="
                  require(imgItem.rightType === 'correct'
                    ? './static/correct-icon.png'
                    : './static/error-icon.png')
                "
                alt=""
                class="img-mark-icon"
              />
              <div :style="$t('remark.style')" class="img-mark">
                {{ imgItem.rightMark }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Jockeys } from '@/utils'

const categoryMap = {
  1: 'shoes', // 鞋
  2: 'clothes', // 服装
  3: 'makeup', // 美妆
  4: 'watch', // 手表
  5: 'bags', // 箱包
}

export default {
  filters: {
    content(area, item) {
      return item[area] || item.content
    },
  },
  data() {
    return {
      area: '',
      pageCfg: [],
    }
  },
  beforeCreate() {
    this.$fontTransform.run(this.$i18n.vm.messages)
  },
  mounted() {
    // 根据参数获取类目的页面配置
    const query = this.$route.query
    const categoryFlag = query.category
    const category = categoryMap[categoryFlag] || 'shoes' // 没有获取到分类信息默认为鞋子
    this.area = query.area || 'HK'
    this.pageCfg = this.$t(`${category}.pageCfg`)
    Jockeys.setTitle(this.$t(`${category}.navTitle`))
  },
  methods: {
    getImgSrcWithOSSResize(src = '', noResize) {
      if (noResize) {
        return src
      }
      if (src.includes('x-oss-process=image')) {
        return `${src}/resize,w_350`
      }
      return `${src}?x-oss-process=image/resize,w_350`
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
